export default __webpack_public_path__ + "4f132fc494bb305eb20d059dd4728efd.svg";